import React from 'react';
import { Card, CardContent } from './ui/card';
import { confirmationPageData } from '../data/mockData';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const ConfirmationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-6 py-20">
      <div className="max-w-2xl w-full">
        <Card className="shadow-2xl border-slate-200">
          <CardContent className="p-12 text-center">
            {/* Success Icon */}
            <div className="mb-8">
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto">
                <CheckCircle2 className="h-12 w-12 text-green-600" />
              </div>
            </div>

            {/* Headline */}
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              Application Received
            </h1>

            {/* Body */}
            <div className="space-y-4 mb-8">
              <p className="text-lg text-slate-700 leading-relaxed">
                {confirmationPageData.headline}
              </p>
              <p className="text-base text-slate-600 leading-relaxed whitespace-pre-line">
                {confirmationPageData.body}
              </p>
            </div>

            {/* Expectation Setting */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
              <p className="text-base text-slate-700 leading-relaxed whitespace-pre-line font-medium">
                {confirmationPageData.expectation}
              </p>
            </div>

            {/* What to Do Next */}
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-8">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">
                What to Do Next
              </h3>
              <p className="text-base text-slate-600 leading-relaxed whitespace-pre-line">
                {confirmationPageData.nextSteps}
              </p>
            </div>

            {/* Back to Home */}
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ConfirmationPage;
